
import { defineComponent } from 'vue';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import 'vue-advanced-cropper/dist/theme.bubble.css';
import config from '@/shared/constants/config';
import { urlJoin } from '@/shared/helpers/urlJoin';

export default defineComponent({
  components: {
    Cropper,
  },
  emits: ['upload', 'close'],
  props: {
    img: {
      type: String,
      required: true,
    },
    accept: {
      type: String,
      default: 'image/jpeg',
    },
    fileName: String,
    aspectRatio: Number,
  },
  data() {
    return {
      size: {
        width: 0,
        height: 0,
      },
    };
  },
  computed: {
    fullUrl(): string {
      if (this.img.indexOf('http') !== 0) {
        return urlJoin(config.BASE_URL, this.img);
      } else {
        return this.img;
      }
    },
    modeClass(): string {
      return this.accept === 'image/png' ? 'cropper--dark' : 'cropper--light';
    },
  },
  methods: {
    rotate(angle: any) {
      (this.$refs.cropper as any).rotate(angle);
    },
    zoom(factor: any) {
      (this.$refs.cropper as any).zoom(factor);
    },
    move(direction: any) {
      if (direction === 'left') {
        (this.$refs.cropper as any).move(-this.size.width / 4);
      } else if (direction === 'right') {
        (this.$refs.cropper as any).move(this.size.width / 4);
      } else if (direction === 'top') {
        (this.$refs.cropper as any).move(0, -this.size.height / 4);
      } else if (direction === 'bottom') {
        (this.$refs.cropper as any).move(0, this.size.height / 4);
      }
    },
    change({ coordinates }: any) {
      this.size.width = Math.round(coordinates.width);
      this.size.height = Math.round(coordinates.height);
    },
    uploadImage() {
      const { canvas } = (this.$refs.cropper as any).getResult();
      if (canvas) {
        canvas.toBlob((blob: any) => {
          if (this.fileName) {
            blob.name = this.fileName;
          }
          this.$emit('upload', blob);
        }, this.accept);
      }
    },
    close() {
      this.$emit('close');
    },
  },
});
